import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Input from "../shared/Input";
import SelectDropdown from "../shared/SelectDropdown";
import {
  fetchData,
  fetchFormData,
  getValueLabel,
  taskPriorityOptions,
  getTodayDateISO,
} from "../../utils/options";
import topTost from "../../utils/topTost";
import TextArea from "../shared/TextArea";

const TaskCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");

  const today = new Date().toISOString().split("T")[0];
  const [formData, setFormData] = useState({
    task_title: "",
    related_member_id: "",
    related_inquiry_id: "",
    priority: "",
    document: "",
    assigned_to: "",
    created_by: "",
    task_completed_on: today,
    status: "",
    task_category: "",
    task_details: "",
    priority: "",
    task_start_date: today,
    task_end_date: today,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [inquiryData, setInquiryData] = useState([]);
  const [taskCategory, setTaskCategory] = useState([]);
  const [userList, setUserList] = useState([]);
  const [taskDetail, setTaskDetail] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!localStorage.getItem("access_token")) {
      navigate("/");
    }
  }, []);

  const handleChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleLeadPriorityChange = (selectedOption) => {
    if (selectedOption) {
      setFormData((prev) => ({
        ...prev,
        priority: selectedOption.value,
      }));
    }
  };

  const handleInquiryChange = (option) => {
    setFormData((prev) => ({
      ...prev,
      related_inquiry_id: option?.value || "",
    }));
  };

  const fetchDetails = async (id) => {
    try {
      const formData = new FormData();
      formData.append("id", id);

      const result = await fetchFormData("task/getbyid", formData, "POST");
      if (result && result.data) {
        setFormData(result.data);
      } else {
        setFormData({});
      }
    } catch (error) {
      console.error("Failed to fetch details:", error);
      setFormData({});
    }
  };

  const fetchAllData = async () => {
    const formData = new FormData();
    formData.append("created_by", userId);
    formData.append("moduleId", M_id);
    formData.append("userId", userId);

    try {
      const taskCategoryData = await fetchFormData(
        "task-category/listDrop",
        formData,
        "POST"
      );
      if (taskCategoryData) {
        setTaskCategory(
          getValueLabel(taskCategoryData.data, "task_category", "id") || []
        );
      }

      const userData = await fetchFormData(
        "get-employees-listuserdrop",
        formData,
        "POST"
      );
      if (userData) {
        setUserList(getValueLabel(userData.users, "name", "id" || []));
      }
    } catch (error) {
      console.error("Error loading data:", error);
    }
  };

  useEffect(() => {
    fetchAllData();
    if (id) {
      fetchDetails(id);
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.task_category) {
      topTost({
        title: "Task category is required",
        icon: "error",
      });
      return;
    }

    setIsSubmitting(true);

    try {
      const form = new FormData();
      form.append("branchID", 1);
      form.append("task_title", formData.task_title);
      form.append("task_details", formData.task_details);
      form.append("assigned_to", formData.assigned_to);
      form.append("priority", formData.priority || "");
      form.append("task_category", formData.task_category);
      form.append("task_completed_on", formData.task_completed_on);
      form.append("task_start_date", formData.task_start_date);
      form.append("task_end_date", formData.task_end_date);
      form.append("moduleId", M_id);

      let response;

      if (id) {
        form.append("id", id);
        form.append("userId", userId);
        // Edit existing user
        response = await fetchFormData("task/update", form, "POST");
      } else {
        // Create new user
        form.append("status", 1);
        form.append("created_by", userId);
        response = await fetchFormData("task/add", form, "POST");
      }

      if ((response && response.code === 200) || response.code === 201) {
        topTost({
          title: response?.message,
          icon: "success",
        });
        navigate(`/task/task-list?id=${M_id}`);
      } else if (response && response.code === 422) {
        topTost({
          title: Array.isArray(response.message)
            ? response.message
            : response.message || "Validation error",
          icon: "error",
        });
      } else {
        topTost({
          title: response?.message || "Operation failed",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Submit error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <div className="col-lg-12">
      <div className="card stretch stretch-full">
        <hr className="mt-0" />
        <div className="card-body general-info">
          <div className="mb-5 d-flex align-items-center justify-content-between">
            <h5 className="fw-bold mb-0 me-4">
              <span className="d-block mb-2">
                {id ? "Edit Task:" : "Add Task:"}
              </span>
            </h5>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6">
                <Input
                  label="Task Title"
                  name="task_title"
                  value={formData.task_title}
                  onChange={handleChange}
                  placeholder="Enter task title"
                  icon="feather-file-text"
                  required
                />
              </div>
              <div className="col-md-2">
                <label className="fw-semibold">
                  Assign To User: <span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-lg-4">
                <SelectDropdown
                  options={userList}
                  selectedOption={
                    userList.find(
                      (opt) => opt.value === formData.assigned_to
                    ) || null
                  }
                  defaultSelect="Select User"
                  onSelectOption={(option) =>
                    setFormData((prev) => ({
                      ...prev,
                      assigned_to: option.value,
                    }))
                  }
                  value={formData.assigned_to}
                  icon="feather-user"
                />
              </div>
            </div>

            {/* <div className="row">
              <div className="col-md-2">
                <label className="fw-semibold">Related Inquiry:</label>
              </div>
              <div className="col-lg-4">
                <SelectDropdown
                  options={inquiryData}
                  selectedOption={
                    inquiryData.find(
                      (opt) => opt.value === formData.related_inquiry_id
                    ) || null
                  }
                  defaultSelect="Select Related Inquiry"
                  onSelectOption={handleInquiryChange}
                  value={formData.related_inquiry_id}
                  icon="feather-flag"
                />
              </div>

              <div className="col-md-6">
                <Input
                  label="Task Code"
                  name="task_code"
                  value={formData.task_code}
                  onChange={handleChange}
                  placeholder="Task Code"
                  icon="feather-hash"
                />
              </div>
            </div> */}

            <div className="row mb-4">
              <div className="col-md-2">
                <label className="fw-semibold">
                  Task Category:
                <span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-lg-4">
                <SelectDropdown
                  options={taskCategory}
                  selectedOption={
                    taskCategory.find(
                      (opt) => opt.value === formData.task_category
                    ) || null
                  }
                  defaultSelect="Select Task Category"
                  onSelectOption={(option) =>
                    setFormData((prev) => ({
                      ...prev,
                      task_category: option.value,
                    }))
                  }
                  value={formData.task_category}
                  icon="feather-layers"
                  required={true}
                />
              </div>

              {/* <div className="col-md-6">
                <Input
                  label="Document"
                  name="document"
                  value={formData.document}
                  onChange={handleChange}
                  placeholder="Document Link or Name"
                  icon="feather-file-text"
                />
              </div> */}

              <div className="col-md-2">
                <label className="fw-semibold">Task Priority:
                  <span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-lg-4">
                <SelectDropdown
                  options={taskPriorityOptions}
                  selectedOption={
                    taskPriorityOptions.find(
                      (opt) => opt.value === String(formData.priority)
                    ) || null
                  }
                  defaultSelect="Select Task Priority"
                  onSelectOption={handleLeadPriorityChange}
                  value={formData.priority}
                  icon="feather-flag"
                  required={true}
                />
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-md-6">
                <Input
                  label="Task Start Date"
                  name="task_start_date"
                  value={formData.task_start_date}
                  onChange={handleChange}
                  type="date"
                  icon="feather-clock"
                  min={today}
                  required
                />
              </div>
              <div className="col-md-6">
                <Input
                  label="Task End Date"
                  name="task_end_date"
                  value={formData.task_end_date}
                  onChange={handleChange}
                  type="date"
                  icon="feather-clock"
                  min={today}
                  required
                />
              </div>
            </div>

            {/* <div className="row">
              <div className="col-md-2">
                <label className="fw-semibold">Assign To User:</label>
              </div>
              <div className="col-lg-4">
                <SelectDropdown
                  options={userList}
                  selectedOption={
                    userList.find(
                      (opt) => opt.value === formData.assigned_to
                    ) || null
                  }
                  defaultSelect="Select User"
                  onSelectOption={(option) =>
                    setFormData((prev) => ({
                      ...prev,
                      assigned_to: option.value,
                    }))
                  }
                  value={formData.assigned_to}
                  icon="feather-user"
                />
              </div>

              <div className="col-md-6">
                <Input
                  label="Created By"
                  name="created_by"
                  value={formData.created_by}
                  onChange={handleChange}
                  placeholder="Created By"
                  icon="feather-user-check"
                  required
                />
              </div>
            </div> */}

            <div className="row">
              {" "}
              <div className="col-md-6">
                <TextArea
                  name="task_details"
                  label="Task Details"
                  labelId="taskDetail"
                  icon="feather-eye"
                  placeholder="Task details"
                  value={formData.task_details}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      [e.target.name]: e.target.value,
                    }))
                  }
                />
              </div>
            </div>

            <div className="mt-4 customButton">
              <button
                type="submit"
                className="btn btn-lg btn-primary"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : id ? "Update" : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
export default TaskCreate;
